import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import { Button } from 'foundations-components/transitional/components/Button';
import { useSignupContext } from '../../../hooks/useSignupContext';
import { ErrorBoundary, ErrorBoundaryNames } from '../../ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const getTtsUrl = () => {
  const langToUrlMap = {
    en: 'https://offers.hubspot.com/contact-sales',
    de: 'https://offers.hubspot.de/contact-sales',
    es: 'https://offers.hubspot.es/contact-sales',
    pt: 'https://br.hubspot.com/ofertas/contact-sales',
    fr: 'https://offers.hubspot.fr/contact-sales',
    ja: 'https://offers.hubspot.jp/contact-sales'
  };
  const lang = getLang();
  return langToUrlMap[lang] || langToUrlMap.en;
};
const PublicTalkToSalesButtonBase = props => {
  const {
    'data-test-id': dataTestId,
    'data-selenium-id': dataSeleniumId,
    apiName,
    ctaType = 'tts',
    children,
    uiButtonProps,
    onClick,
    trackingData
  } = props;
  const purchaseMotion = 'TALK_TO_SALES';
  const {
    hubsSignupUrl,
    hubsSignupCta
  } = useSignupContext({
    apiName,
    ctaType,
    trackingData
  });
  const ttsUrl = useMemo(() => {
    const baseUrl = getTtsUrl();
    const params = new URLSearchParams({
      'hubs_signup-url': hubsSignupUrl,
      'hubs_signup-cta': hubsSignupCta
    });
    return `${baseUrl}?${params.toString()}`;
  }, [hubsSignupUrl, hubsSignupCta]);
  const handleClick = () => {
    onClick === null || onClick === void 0 || onClick(purchaseMotion);
  };
  const buttonText = children || /*#__PURE__*/_jsx(FormattedMessage, {
    message: "purchaseMotions.buttons.talkToSales"
  });
  return /*#__PURE__*/_jsx(Button, Object.assign({
    "data-test-id": dataTestId !== null && dataTestId !== void 0 ? dataTestId : 'talk-to-sales-button',
    "data-selenium-id": dataSeleniumId,
    use: "primary",
    truncate: false
  }, uiButtonProps, {
    href: ttsUrl,
    external: true,
    onClick: handleClick,
    children: buttonText
  }));
};
export const PublicTalkToSalesButton = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: ErrorBoundaryNames.TALK_TO_SALES_BUTTON,
  children: /*#__PURE__*/_jsx(PublicTalkToSalesButtonBase, Object.assign({}, props))
});